import { render, staticRenderFns } from "./AlphaFoldViewer.vue?vue&type=template&id=5154bef3&scoped=true"
import script from "./AlphaFoldViewer.vue?vue&type=script&lang=js"
export * from "./AlphaFoldViewer.vue?vue&type=script&lang=js"
import style0 from "./AlphaFoldViewer.vue?vue&type=style&index=0&id=5154bef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154bef3",
  null
  
)

export default component.exports